module.exports = __webpack_public_path__ + "./fonts/app.9b58e6389c0d507212f5392b191a9643.woff";